import { format } from "date-fns";

const BOM = "\uFEFF";

export const downloadCsvFile = (csvContent: string): string => {
  const filename = `CSVダウンロード_${format(new Date(), "yyyyMMdd_HHmmss")}.csv`;

  const contentWithBom = csvContent.startsWith(BOM)
    ? csvContent
    : BOM + csvContent;
  const blob = new Blob([contentWithBom], { type: "text/csv;charset=utf-8;" });
  const blobUrl = URL.createObjectURL(blob);
  const downloadLink = document.createElement("a");

  downloadLink.style.display = "none";
  downloadLink.href = blobUrl;
  downloadLink.download = filename;

  document.body.appendChild(downloadLink);
  downloadLink.click();

  document.body.removeChild(downloadLink);
  URL.revokeObjectURL(blobUrl);

  return filename;
};
